import { render, staticRenderFns } from "./CommentsFromPage.vue?vue&type=template&id=d36856f6&scoped=true&"
import script from "./CommentsFromPage.vue?vue&type=script&lang=js&"
export * from "./CommentsFromPage.vue?vue&type=script&lang=js&"
import style0 from "./CommentsFromPage.vue?vue&type=style&index=0&id=d36856f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36856f6",
  null
  
)

export default component.exports